export default __webpack_public_path__ + "static/media/hourglassList.81a41149.svg";